<template>
  <common-dialog ref="dialog" width="400px" show-save-button title="修改密码" id-key="mallId" :data="data"
    :form-rules="rules" :save-func="saveDataFunc" @close-saved="$emit('close-saved')" close-on-saved>
    <template slot="form">
      <el-form-item label="用户名">
        <el-input v-model="data.userName" disabled></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPwd">
        <el-input show-password v-model.trim="data.newPwd" />
      </el-form-item>
      <el-form-item label="确认密码" prop="confirmPwd">
        <el-input show-password v-model.trim="data.confirmPwd" />
      </el-form-item>
    </template>
  </common-dialog>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog';
import commonDialog from '@/components/common/dialog';

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    let validator = (rule, value, callback) => {
      if (this.data.newPwd == "" || this.data.confirmPwd == "") {
        callback();
      }
      if (this.data.newPwd != this.data.confirmPwd) {
        callback("密码不一致");
      } else {
        callback();
      }
    };
    return {
      api: require('@/api/pdd/mall').default,
      data: {
        mallId: null,
        userName: "",
        newPwd: "",
        confirmPwd: ""
      },
      rules: {
        userName: [{ required: true, message: '用户名不能为空' }],
        newPwd: [
          { required: true, message: "新密码不能为空" },
          // { validator: this.$commonJs.validateRules.validPwd },
          { validator: validator },
        ],
        confirmPwd: [
          { required: true, message: "确认密码不能为空" },
          { validator: validator },
        ],
      },
    };
  },
  methods: {
    saveDataFunc() {
      return new Promise((resolve, reject) => {
        var data = {
          mallId: this.data.mallId,
          userName: this.data.userName,
          userPwd: this.data.newPwd,
          saveType: 1 // 0：保存用户名，1：保存密码
        }
        this.api.saveUser(data).then(res => {
          resolve({ Code: 0, Msg: null })
        }).catch((error) => {
          reject(error)
        })
      })
    }
  },
};
</script>
